import { Modal, Text } from "@mantine/core";
import React from "react";

const DocxDemodataModal: React.FC<{ docxDemoData: any; close: () => void }> = ({ docxDemoData, close }) => {
  return (
    <Modal opened onClose={close} title="Datamodell" size="lg">
      <div style={{ height: "1000px", overflow: "auto" }}>
        <div className="bg-dark" style={{ display: "flex", flexDirection: "column" }}>
          <Text component="pre" c="white">
            {JSON.stringify(docxDemoData, null, 2)}
          </Text>
        </div>
      </div>
    </Modal>
  );
};

export default DocxDemodataModal;
